module.exports = __webpack_public_path__ + "static/media/how_we_keep_your_data_secure.080b00ef.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tab-images/how_we_keep_your_data_secure.jpg
// module id = 221
// module chunks = 0